import { getAllCategories } from '../../../redux/categoriesRedux';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import ListGroup from 'react-bootstrap/ListGroup';
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { capitalizeFirstLetter } from "../../../utils/capFirstLetter";
const Categories = () => {
    
  const categories = useSelector( getAllCategories );

  return (
  <>        
    <h2>All categories</h2>
    <Container>
            <Row className='justify-content-center align-items-center text-center w-100'>
              <Col>
                <ListGroup>
                  {categories.map(cat => 
                      <ListGroup.Item key={`category-${cat}`} ><Nav.Link as={NavLink} to={"/category/" + cat}>{capitalizeFirstLetter(cat)}</Nav.Link></ListGroup.Item>
                  )}
                </ListGroup>
              </Col>
            </Row>
    </Container>
  </>
  );
};

export default Categories;
